import { Deal } from "@Types/deal";

import { CommonProps } from "../SupportMachine/types";
import { handleInteraction } from "../SupportMachine/stateMachineInteractions";
import ChatSearch from "@Components/ChatSearch";

const SelectLoan = ({ index, state, setState }: CommonProps) => {
  const handleSelectDeal = (deal: Deal) => {
    handleInteraction({
      prevState: state,
      optionIndex: index || 0,
      currentState: state.name,
      setState,
      deal,
    });
  };

  return <ChatSearch handleSelectDeal={handleSelectDeal} />;
};

export default SelectLoan;
